import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Tooltip,
  Typography,
  CircularProgress,
} from "@mui/material";
import RightViewLayout from "../../components/RighViewLayout";
import CustomInput from "../../components/CustomInput";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  createRole,
  getMenuItems,
  getMenus,
} from "../../services/UserManagementService";
import { REACT_AUTHORIZATION_LEVEL } from "../../router/ReactEndPoints";
import { useSnackbar } from "notistack";
import CommonUtil from "../../util/CommonUtils";
import { handleCheckboxChange } from "./checkBox.js";
export default function AddAuthorizationLevel() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [menus, setMenus] = useState([]);

  const loadData = () => {
    getMenus().then((res) => {
      if (res?.data?.code == "LVLI0000") {
        setMenus(res?.data?.data);
      }
    });
  };

  useEffect(() => {
    loadData();
  }, []);

  const [payload, setPayload] = useState({
    name: "",
    code: "",
    permissionIds: [],
  });

  const [error, setError] = useState({
    name: "",
    code: "",
    permissionIds: "",
  });

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });

    setError({
      ...error,
      [name]: "",
      common: "",
    });
  };

  const changeFun = (values, isParent, type) => {
    handleCheckboxChange(menus, setSelectedPermissions, values, isParent, type);
  };


  useEffect(() => {
    setPayload({
      ...payload,
      permissionIds: selectedPermissions,
    })
  }, [selectedPermissions])


  const validateForm = () => {
    if (CommonUtil.isEmptyString(payload.name)) {
      enqueueSnackbar(t("tips_authorization.requires_name"), {
        variant: "error",
      });
      return;
    }
    if (CommonUtil.isEmpty(payload.permissionIds)) {
      enqueueSnackbar(t("tips_authorization.requires_permission"), {
        variant: "error",
      });
      return;
    }
    return true;
  };


  const handleSubmit = () => {
    if (validateForm()) {
      let parmas = {
        ...payload,
        permissionIds: selectedPermissions
      }
      createRole(parmas).then((res) => {
        if (res?.data?.code === "LVLI0008") {
          enqueueSnackbar(t("tips_authorization.created"), {
            variant: "success",
          });
          navigate(REACT_AUTHORIZATION_LEVEL);
        }
        if (res?.data?.code !== "LVLI0008") {
          enqueueSnackbar(res.data.message, { variant: "error" });
          return;
        }
      });
    }
  };




  return (
    <RightViewLayout
      title={t("authorization.add")}
      navigateBack={REACT_AUTHORIZATION_LEVEL}>
      <Box pr={2}>
        <Card
          elevation={0}
          sx={{
            background: " #FFFFFF 0% 0% no-repeat padding-box",
            fontWeight: "bold",
            opacity: 1,
            borderRadius: "8px",
          }}>
          <CardContent
            style={{
              width: "30%",
            }}>
            <CustomInput
              resetError={() => setError({ ...error, name: "" })}
              required
              error={error.name}
              label={t("authorization.name")}
              size="small"
              name="name"
              value={payload.name}
              helperText={error.name}
              // validation="alpha-numeric-ch-th"
              handleChange={handleChange}
              inputProps={{
                maxLength: 50,
              }}
              labelSize="20px"
              placeholder={t("tips_authorization.name")}
            />
          </CardContent>
        </Card>
        <Typography
          pt={1}
          pl={0}
          sx={{
            textAlign: "left",
            font: "normal normal medium 16px/22px Roboto",
            fontWeight: "bold",
            letterSpacing: "0px",
            opacity: "0.8",
          }}>
          {t("authorization.list")}
        </Typography>

        {menus?.map((menu) => {
          return (
            <Grid key={menu.id} pt={1.5}>
              <Card
                elevation={0}
                sx={{
                  background: "#FFFFFF 0% 0% no-repeat padding-box",
                  fontWeight: "bold",
                  borderRadius: "8px",
                }}>
                <FormGroup
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    ml: 4, // 设置左边距
                  }}>
                  <Grid lg={2}>
                    <FormControlLabel
                      key={menu.id}
                      control={
                        <Checkbox
                          id={`permission-checkbox-${menu.id}`}
                          checked={selectedPermissions?.includes(menu.id)}
                          onChange={() =>
                            changeFun(menu.id, null, "1")
                          }
                        />
                      }
                      label={menu.name}
                      sx={{
                        textAlign: "left",
                        font: "normal normal medium 28px/38px Roboto",
                        fontWeight: "bold",
                        letterSpacing: "0px",
                        color: "#474B4F",
                      }}
                    />
                  </Grid>
                </FormGroup>



                <CardContent>
                  {menu?.menuItemList?.map((item) => (
                    <Grid
                      key={item.id}
                      sx={{
                        textAlign: "left",
                        font: "normal normal medium 32px/38px Roboto",
                        letterSpacing: "0px",
                        color: "#474B4F",
                      }}>
                      <FormGroup
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          ml: 6, // 设置左边距
                        }}>
                        <Grid lg={2}>
                          {item.name !== null ? (
                            <FormControlLabel
                              key={item.id}
                              control={
                                <Checkbox
                                  id={`permission-checkbox-${item.id}`}
                                  checked={selectedPermissions?.includes(
                                    item.id
                                  )}
                                  onChange={() =>
                                    changeFun(item.id, menu.id, "2")
                                  }
                                />
                              }
                              label={item.name}
                              sx={{
                                textAlign: "left",
                                font: "normal normal medium 18px/24px Roboto",
                                fontWeight: "bold",
                                letterSpacing: "0px",

                                color: "#474B4F",
                              }}
                            />
                          ) : null}
                        </Grid>
                      </FormGroup>

                      <FormGroup
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          ml: 12,
                        }}>
                        {item?.permissionList.map((permission) => (
                          <Grid lg={2}>
                            <FormControlLabel
                              key={permission.id}
                              control={
                                <Checkbox
                                  id={`permission-checkbox-${permission.id}`}
                                  checked={selectedPermissions?.includes(
                                    permission.id
                                  )}
                                  onChange={() =>
                                    changeFun(
                                      permission.id,
                                      item.id,
                                      "3"
                                    )
                                  }
                                />
                              }
                              label={permission.name}
                              sx={{
                                width: 200,
                                mt: 1,
                              }}
                            />
                          </Grid>
                        ))}
                      </FormGroup>
                    </Grid>
                  ))}
                </CardContent>
              </Card>
            </Grid>
          );
        })}

        <Grid container spacing={2} pb={2} paddingBottom={"15px"} mt={2}>
          <Grid item xs={12}>
            <Box display={"flex"} flexDirection={"row-reverse"}>
              <Box item pl={2}>
                <Button
                  id="AddAuthorizationLevel-button-01"
                  variant="contained"
                  size="large"
                  className="text-transform-none"
                  onClick={handleSubmit}
                  style={{
                    size: "medium",
                    borderRadius: "8px",
                    opacity: 1,
                    background:
                      "transparent linear-gradient(270deg, #1487CA 0%, #78BC27 100%) 0% 0% no-repeat padding-box",
                  }}>
                  {t("common.save")}
                </Button>
              </Box>
              <Box item>
                <Button
                  id="AddAuthorizationLevel-button-02"
                  className="text-transform-none"
                  variant="outlined"
                  onClick={() => navigate(REACT_AUTHORIZATION_LEVEL)}
                  size="large">
                  {t("common.back")}
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </RightViewLayout>
  );
}

//   permissions?.filter((x) => x.i18nKey == menu.i18nKey).length >
//   0 && (
//     <Grid key={menu.id} pt={1.5}>
//       <Card
//         elevation={0}
//         sx={{
//           background: " #FFFFFF 0% 0% no-repeat padding-box",
//           fontWeight: "bold",
//           opacity: 1,
//           borderRadius: "8px",
//         }}>
//         <CardContent>
//           <FormControlLabel
//             key={menu.id}
//             control={
//               <Checkbox
//                 id={`permission-checkbox-${menu.id}`}
//                 checked={checkedMenus[menu.id] || false}
//                 onChange={() => handleMenuCheckboxChange(menu.id)}
//               />
//             }
//             label={label(t(menu.name))}
//           />
//           <Card elevation={0} style={{ width: "100%" }}>
//             <CardContent style={{ paddingTop: 1, paddingBottom: 1 }}>
//               {menuItems
//                 .filter((menuItem) => {
//                   return menuItem.menu.i18nKey === menu.i18nKey;
//                 })
//                 .map((menuItem) => {
//                   return (
//                     <Grid key={menuItem.id}>
//                       <FormControlLabel
//                         key={menuItem.id}
//                         control={
//                           <Checkbox
//                             id={`permission-checkbox-${menuItem.id}`}
//                             checked={
//                               checkedMenuItems[menuItem.id] || false
//                             }
//                             onChange={() =>
//                               handleMenuItemCheckboxChange(
//                                 menuItem.id
//                               )
//                             }
//                           />
//                         }
//                         label={childLabel(t(menuItem.name))}
//                       />
//                       <Grid key={menuItem.id} pl={2}>
//                         <Card elevation={0} style={{ width: "100%" }}>
//                           <CardContent
//                             style={{
//                               paddingTop: 1,
//                               paddingBottom: 1,
//                             }}>
//                             <FormGroup row key={menuItem.id}>
//                               {permissions
//                                 .filter(
//                                   (permission) =>
//                                     permission.menuItem.i18nKey ===
//                                     menuItem.i18nKey
//                                 )
//                                 .map((permission) => (
//                                   <Grid
//                                     lg={2.4}
//                                     sx={{
//                                       textAlign: "left",
//                                       font: "normal normal medium 16px/21px Roboto",
//                                       letterSpacing: "0px",
//                                       opacity: "0.8",
//                                       color: "#474B4F",
//                                     }}
//                                     key={permission.id}>
//                                     <FormControlLabel
//                                       key={permission.id}
//                                       control={
//                                         <Checkbox
//                                           id={`permission-checkbox-${permission.id}`}
//                                           checked={
//                                             checkedPermissions[
//                                             permission.id
//                                             ] || false
//                                           }
//                                           onChange={() =>
//                                             handlePermissionCheckboxChange(
//                                               permission.id
//                                             )
//                                           }
//                                         />
//                                       }
//                                       label={subChildLabel(
//                                         t(permission.name)
//                                       )}
//                                     />
//                                   </Grid>
//                                 ))}
//                             </FormGroup>
//                           </CardContent>
//                         </Card>
//                       </Grid>
//                     </Grid>
//                   );
//                 })}
//             </CardContent>
//           </Card>
//         </CardContent>
//       </Card>
//     </Grid>
//   )
// );
